import { Link } from "react-router-dom";

import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const LinkStyled = styled(Link)`
    text-decoration: none;

    &:hover,
    &:active,
    &:focus {
        text-decoration: none;
    }
`;

export const linkColorClassName = css`
    color: ${Colors.Blue.V200};
`;
